<div [formGroup]="group" class="dynamicForm_alignment">
  <div style="display: grid;">
    <label class="radio-label-padding">{{field.labelName}} @if (isRequired) {
      <span>*</span>
    }</label>
    @if (field.description) {
      <p class="description" [innerHTML]="field.description"></p>
    }
  </div>
  <mat-radio-group [formControlName]="field.labelCode" class="displayGrid" [required]="isRequired">
    @for (item of sortedOptions; track item) {
      <mat-radio-button [value]="item.code">{{item.value}}
      </mat-radio-button>
    }
  </mat-radio-group>
</div>

